export const GET_PROMOEVENTS = "GET_PROMOEVENTS";
export const SET_PROMOEVENTS = "SET_PROMOEVENTS";
